import {STORE_APP_MUTATION_TYPES, STORE_APP_STORAGE_KEYS} from '../../libs/constants'
import util from '../../libs/util'
import api from '../../config/api'

const app = {
  state: {
    oldPlatformUrl: 'http://cep.webtrn.cn',
    showLeftMenu: true, // 是否显示左侧菜单
    currentPageId: '', // 当前页面name
    currentTab: {id: '', routers: []}, // 当前激活的标签
    currentLeftMenuId: '', // 当前左侧菜单
    topTabList: [], // 当前打开的标签列表
    cachedViews: [],
    showIframe: false,
    peWebSiteDetail: {}, // 站点详情信息
    useSso: false, // 是否使用用户中心
    ssoBasePath: {}, // 站点域名与用户中心根路径关系
    client_id: '',
    enableSendSiteInfo: true, // 是否发送站点信息
    siteInfo: {}, // 站点信息,保存一些额外的信息
    defaultMenu: {} // 默认打开的菜单
  },
  mutations: {
    [STORE_APP_MUTATION_TYPES.RESET_APP_STATE] (state) { // reset app state
      state.showLeftMenu = true
      state.currentPageId = ''
      state.currentTab = {id: '', routers: []}
      state.currentLeftMenuId = ''
      state.topTabList = []
      state.cachedViews = []
      state.showIframe = false
    },
    [STORE_APP_MUTATION_TYPES.INIT_TOP_TAB_LIST] (state) { // 从缓存中读取topTabList
      if (localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST)) {
        state.topTabList = JSON.parse(localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST))
      }
    },
    [STORE_APP_MUTATION_TYPES.INIT_CURRENT_PAGE] (state) { // 从缓存中读取当前页
      if (localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID)) {
        state.currentPageId = localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID)
      }
    },
    [STORE_APP_MUTATION_TYPES.INIT_CURRENT_TAB] (state) { // 从缓存中读取当前激活标签
      if (localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB)) {
        state.currentTab = JSON.parse(localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB))
      }
    },
    [STORE_APP_MUTATION_TYPES.INIT_CACHED_VIEWS] (state) { // 初始化cachedViews
      if (localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST)) {
        JSON.parse(localStorage.getItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST)).map(item => {
          state.cachedViews.push(item.id)
        })
      }
    },
    [STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB](state, payload) { // 新增一个顶部标签
      // 检查要新增的标签是否已经存在
      let isOpened = false
      state.topTabList.map(item => {
        if (item.id === payload.id) {
          isOpened = true
        }
      })
      // 如果标签不存在,则新增标签,并把标签放入路由缓存数组中
      if (!isOpened) {
        state.topTabList.push(payload)
        this.commit(STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS, {id: payload.id})
        localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
      }
    },
    [STORE_APP_MUTATION_TYPES.REMOVE_TAB_BY_ID](state, payload) { // 根据name删除topTab
      let i = state.topTabList.length
      while (i--) {
        if (state.topTabList[i].id === payload.id) {
          this.commit(STORE_APP_MUTATION_TYPES.CLEAR_ONE_TAB_CACHE, state.topTabList[i])
          state.topTabList.splice(i, 1)
          if (payload.id === state.currentPageId) {
            let nextActiveTab = state.topTabList[i] || state.topTabList[i - 1]
            state.currentPageId = nextActiveTab ? nextActiveTab.id : ''
            state.currentTab = nextActiveTab || {}
            state.currentLeftMenuId = state.currentPageId
          }
          break
        }
      }
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB, JSON.stringify(state.currentTab))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID, state.currentPageId)
    },
    [STORE_APP_MUTATION_TYPES.CLEAR_ONE_TAB_CACHE](state, payload) { // 清除一个top tab的缓存
      if (payload && payload.id) {
        this.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, {id: payload.id})
        if (payload.routers && payload.routers.length > 0) {
          for (let i = 0; i < payload.routers.length; i++) {
            this.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, {id: payload.routers[i].name})
          }
        }
      }
    },
    [STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS](state, payload) {
      let has = false
      const dest = util.getDestRouter(payload)
      state.cachedViews.map(item => {
        if (item === dest.name) {
          has = true
        }
      })
      if (!has) {
        state.cachedViews.push(dest.name)
      }
    },
    [STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS](state, payload) { // 根据name删除缓存组件
      let j = state.cachedViews.length
      const dest = util.getDestRouter(payload)
      while (j--) {
        if (state.cachedViews[j] === dest.name) {
          state.cachedViews.splice(j, 1)
          break
        }
      }
    },
    [STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE](state, payload) { // 更新当前页面
      state.currentPageId = payload.id
      state.currentTab = payload
      state.showIframe = false
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB, JSON.stringify(state.currentTab))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID, state.currentPageId)
    },
    [STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_LEFT_MENU](state, payload) { // 更新当前左侧菜单
      state.currentLeftMenuId = payload.id
    },
    [STORE_APP_MUTATION_TYPES.SET_SHOW_LEFT_MENU](state, payload) { // 更新是否显示左侧菜单
      state.showLeftMenu = payload
    },
    [STORE_APP_MUTATION_TYPES.CLOSE_OTHER_TABS](state, payload) { // 关闭其他tab
      let i = state.topTabList.length
      while (i--) {
        if (state.topTabList[i].id === payload.id) {
          state.currentPageId = payload.id
          state.currentTab = payload
          state.currentLeftMenuId = state.currentPageId
        } else {
          state.topTabList.splice(i, 1)
        }
      }
      let j = state.cachedViews.length
      const dest = util.getDestRouter(payload)
      while (j--) {
        if (state.cachedViews[j] !== dest.name) {
          state.cachedViews.splice(j, 1)
        }
      }
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB, JSON.stringify(state.currentTab))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID, state.currentPageId)
    },
    [STORE_APP_MUTATION_TYPES.CLOSE_ALL_TABS](state) { // 关闭所有tab
      state.currentPageId = ''
      state.currentTab = {}
      state.currentLeftMenuId = ''
      state.topTabList = []
      state.cachedViews = []
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB, JSON.stringify(state.currentTab))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID, state.currentPageId)
    },
    [STORE_APP_MUTATION_TYPES.SHOW_IFRAME](state) {
      state.showIframe = true
    },
    [STORE_APP_MUTATION_TYPES.HIDDEN_IFRAME](state) {
      state.showIframe = false
    },
    // 保存没有多级列表关系的标签列表
    [STORE_APP_MUTATION_TYPES.STORE_TOPTABLIST](state) {
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
    },
    // 跳转下一级列表需要调用的方法，如自定义菜单中的二级列表
    [STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_ROUTES_FORWARD](state, route) {
      if (!state.currentTab.routers) {
        state.currentTab.routers = []
      }
      state.currentTab.routers.push(route)
      const currentTab = state.currentTab
      let tabList = state.topTabList
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].id === currentTab.id) {
          state.topTabList[i].routers = currentTab.routers
          break
        }
      }
      this.commit(STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS, {id: route.name})
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB, JSON.stringify(state.currentTab))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
    },
    // 返回上一级列表需要调用的方法
    [STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_ROUTES_BACK](state, payload) {
      let routerName = payload && payload.routerName
      if (state.currentTab.routers && state.currentTab.routers.length > 0) {
        // 回退操作
        let findRouter = false
        let backSteps = 0
        if (routerName) {
          for (let i = state.currentTab.routers.length - 2; i >= 0; i--) {
            backSteps++
            if (state.currentTab.routers[i].name === routerName) {
              findRouter = true
              break
            }
          }
          // 判断是否回退到第一个路由
          if (!findRouter && state.currentTab.id === routerName) {
            backSteps++
            findRouter = true
          }
        }
        if (findRouter) {
          for (let i = 0; i < backSteps; i++) {
            this.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, {id: state.currentTab.routers[state.currentTab.routers.length - 1].name})
            state.currentTab.routers.pop()
          }
        } else { // 如果给定的routerName没有找到，则默认回退一级
          this.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, {id: state.currentTab.routers[state.currentTab.routers.length - 1].name})
          state.currentTab.routers.pop()
        }
        const toRoute = util.getDestRouter(state.currentTab)
        // 更新topTabList中对应的currentTab的信息
        const currentTab = state.currentTab
        let tabList = state.topTabList
        for (let i = 0; i < tabList.length; i++) {
          if (tabList[i].id === currentTab.id) {
            state.topTabList[i].routers = currentTab.routers
          }
        }
        this.commit(STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS, {id: toRoute.name})
      } else {
        state.currentTab.routers = []
      }
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.CURRENT_TAB, JSON.stringify(state.currentTab))
      localStorage.setItem(util.user() + STORE_APP_STORAGE_KEYS.TOP_TAB_LIST, JSON.stringify(state.topTabList))
    },
    [STORE_APP_MUTATION_TYPES.INIT_SITE_DETAIL_INFO](state) {
      state.client_id = util.getClientIdByDomain()
      api.querySiteDetailInfo().then(response => {
        const result = response.data
        if (result.meta.errCode === 0) {
          state.peWebSiteDetail = result.data.peWebSiteDetail
          state.useSso = result.data.useSso
          state.ssoBasePath = result.data.ssoBasePath
          document.title = (state.peWebSiteDetail && state.peWebSiteDetail.title) ? state.peWebSiteDetail.title : '管理平台'

          state.siteInfo = result.data.siteInfo
          // 收集站点信息
          if (state.enableSendSiteInfo && state.siteInfo && state.siteInfo.sendSiteInfo) {
            let params = JSON.parse(JSON.stringify(state.siteInfo))
            delete params['sendSiteInfo']
            util.ajax.post('http://demo.admin.webtrn.cn', {params}).then((res) => {
              if (res.data.meta.errCode !== 0) {
                console.warn('send site info failed.')
              }
            }).catch(() => {
              console.warn('send site info failed.')
            })
          }
        } else {
          console.error('获取站点信息失败：' + result.meta.errMsg)
        }
      })
    },
    [STORE_APP_MUTATION_TYPES.SET_DEFAULT_MENU](state, payload) { // 设置默认展示的菜单
      state.defaultMenu = payload
    }
  },
  actions: {
    initAppInfo({ commit }) {
      commit(STORE_APP_MUTATION_TYPES.INIT_SITE_DETAIL_INFO)
    },
    initStateAfterLogin({commit}) {
      commit(STORE_APP_MUTATION_TYPES.INIT_TOP_TAB_LIST)
      commit(STORE_APP_MUTATION_TYPES.INIT_CURRENT_PAGE)
      commit(STORE_APP_MUTATION_TYPES.INIT_CURRENT_TAB)
      commit(STORE_APP_MUTATION_TYPES.INIT_CACHED_VIEWS)
    }
  }

}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js